import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AttendanceService } from 'src/app/service/attendance.service';
@Component({
  selector: 'app-type-create',
  templateUrl: './type-create.component.html',
  styleUrls: ['./type-create.component.scss']
})
export class TypeCreateComponent implements OnInit {

  showLoader: boolean = false;
  creating: boolean = false;
  ShowFilter = true;

  avaRoles: any;
  allIsps: any;

  createAttendanceType = new FormGroup({
    code: new FormControl('', [
      Validators.required,
    ]),
    nameAr: new FormControl('', [
      Validators.required, 
      ]),
    nameEn: new FormControl('', [
      Validators.required,
      ]),
    factor: new FormControl('', [
        Validators.required,
        ]),
    
    
  }, );

  constructor(
    private attendanceService:AttendanceService,
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private coursesService: CoursesService
    , private roleService: RoleService
    , private orgService: OrgService
  ) {

  }

  // changeRole(e: any) {
  //   this.createAttendanceType.value.roleType = e.target.value, {
  //     onlySelf: true
  //   }
  // }
  ngOnInit(): void {
   
  }

  createAttendanceTypeChange() {
    // let classHours = this.createAttendanceType.controls.classHours.value;
    // let clinicalHours = this.createAttendanceType.controls.clinicalHours.value;
    // this.createAttendanceType.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  createAttendanceTypeSubmit() {
    if (this.createAttendanceType.valid) {
      // call your service 
      let code = this.createAttendanceType.controls.code.value;
      let nameAr = this.createAttendanceType.controls.nameAr.value;
      let nameEn = this.createAttendanceType.controls.nameEn.value;
      let factor=this.createAttendanceType.controls.factor.value;
      let elFactor=0;
      if(factor=="YES"){
        elFactor=1;
      }else{
        elFactor=0;
      }
      
      this.addAttendanceType(code, nameAr, nameEn, "YES",elFactor)
    }
    else {
      this.createAttendanceType.markAllAsTouched();
      this.createAttendanceType.markAsDirty();
    }
  }

  addAttendanceType(code: string, nameAr: string, nameEn: string, active: string,elFactor:any) {
    this.creating = true;
    let username = this.globals.currentUserInfo.username;

    this.attendanceService.addAttendanceType(username, 10, code, nameAr, nameEn, active,elFactor)
      .subscribe(
        data => {
          console.log(data);
          if (data.sts == "SUCCESS") {
            this.creating = false;
            this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
            this.router.navigate(['/attendence/type']);
          } else {
            this.creating = false;
            this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
          }
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }
 



  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }
  changegender(){

  }

}
